<script setup>
import { storeToRefs } from 'pinia';
import useAccountStore from '../store/account';
import BankAccount from './payment/BankAccount.vue';
import PaymentMethodEmptyState from './payment/PaymentMethodEmptyState.vue';
import { trans } from '../../../_00_elements/translation';

const store = useAccountStore();

store.setPayOrganizationSeller(window.initialState.payOrganizationSeller);
store.setPayOrganizationBuyer(window.initialState.payOrganizationBuyer);
store.setPaymentMethod(window.initialState.paymentMethod);
store.setPortalLink(window.initialState.stripePortalLink);

const { payOrganizationSeller, payOrganizationBuyer, paymentMethod } = storeToRefs(store);
</script>

<template>
  <div class="payment-method">
    <h1>{{ trans('gestion.pay.payment_method.title') }}</h1>

    <div class="payment-method__container">
      <PaymentMethodEmptyState v-if="(!payOrganizationSeller && !payOrganizationBuyer) || !paymentMethod" />
      <BankAccount v-else />
    </div>
  </div>
</template>
